import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faSearch,
  faInfoCircle,
  faFileExcel,
} from "@fortawesome/free-solid-svg-icons";
import { BodyAsFormData } from "../../../services/utilities/util";
import FilterContext from "../../../routes/FilterContext";
import { apiMiddleware } from "../../../services/apis/apiMiddleware";
import { connect } from "react-redux";
import { JsonToExcel } from "react-json-to-excel";

function mapStateToProps(state) {
  return { filters: state.selectedFilters };
}
class AssetDetails extends React.Component {
  static contextType = FilterContext;

  state = {
    assetDetails: [],
    filters: "",
    excelData: {},
  };

  constructor(props) {
    super(props);
  }

  componentDidMount() {
    var filters;
    if (JSON.stringify(this.props.filters) == "{}") {
      filters = JSON.stringify(this.context.filters);
    } else {
      filters = JSON.stringify(this.props.filters);
    }
    this.state.filters = filters;
    apiMiddleware
      .post("api/edge/office/get_asset_details", BodyAsFormData(filters))
      .then((res) => {
        this.setState({ assetDetails: res.data }, () => {
          this.state.excelData = {
            Asset_Name: this.state.assetDetails.asset_name,
            Property_Type: this.state.assetDetails.propertytype,
            Grade: this.state.assetDetails.grade,
            Year_Constructed: this.state.assetDetails.year_constructed,
            Developer: this.state.assetDetails.developer,
            Status: this.state.assetDetails.status,
            Total_Leasable_Area: this.state.assetDetails.total_leasable_area,
            Area_Vacant: this.state.assetDetails.area_vacant,
            Asset_Efficiency: this.state.assetDetails.asset_efficiency,
            WALE: this.state.assetDetails.wale,
            No_Of_Active_Tenants: this.state.assetDetails.no_of_active_tenants,
            Upcoming_Area: this.state.assetDetails.upcoming_area,
            Market_Rent: this.state.assetDetails.market_rent,
            Five_Year_cagr_Rent: this.state.assetDetails.five_year_cagr_rent,
            Current_Vacancy: this.state.assetDetails.current_vacancy,
            Current_In_Place_Rentals:
              this.state.assetDetails.current_in_place_rentals,
            occupancy_last_updated: this.state.assetDetails.occupancy_last_updated
          };
        });
      });
  }

  componentDidUpdate() {
    if (this.props.filters != this.state.filters){
      this.setState({ filters: this.props.filters });

      apiMiddleware
        .post(
          "api/edge/office/get_asset_details",
          BodyAsFormData(JSON.stringify(this.props.filters))
        )
        .then((res) => {
          this.setState({ assetDetails: res.data }, () => {
            this.state.excelData = {
              Asset_Name: this.state.assetDetails.asset_name,
              Property_Type: this.state.assetDetails.propertytype,
              Grade: this.state.assetDetails.grade,
              Year_Constructed: this.state.assetDetails.year_constructed,
              Developer: this.state.assetDetails.developer,
              Status: this.state.assetDetails.status,
              Total_Leasable_Area: this.state.assetDetails.total_leasable_area,
              Area_Vacant: this.state.assetDetails.area_vacant,
              Asset_Efficiency: this.state.assetDetails.asset_efficiency,
              WALE: this.state.assetDetails.wale,
              No_Of_Active_Tenants:
                this.state.assetDetails.no_of_active_tenants,
              Upcoming_Area: this.state.assetDetails.upcoming_area,
              Market_Rent: this.state.assetDetails.market_rent,
              Five_Year_cagr_Rent: this.state.assetDetails.five_year_cagr_rent,
              Current_Vacancy: this.state.assetDetails.current_vacancy,
              Current_In_Place_Rentals:
                this.state.assetDetails.current_in_place_rentals,
              occupancy_last_updated: this.state.assetDetails.occupancy_last_updated
            };
          });
        });
    }
  }

  render() {
    return (
      <div
        className="widget widgetAsset"
        style={{ paddingTop: "0", paddingBottom: "0" }}
      >
        <div className="row">
          <div className="col-lg-2 assetImgContainer">
            <img src={this.state.assetDetails.image} />
            {this.state.assetDetails.occupancy_last_updated != '-' && (
              <>
            <p>Occupancy Last Updated - {this.state.assetDetails.occupancy_last_updated}</p>
            </>)}
          </div>
          <div className="col-lg-8 aseetContent">
            <h2>
              {this.state.assetDetails.asset_name}
              <span className="assetExcelBtn">
                <JsonToExcel
                  title={
                    <FontAwesomeIcon
                      icon={faFileExcel}
                      className="colorWhite"
                    />
                  }
                  data={[this.state.excelData]}
                  fileName="asset_details"
                  btnClassName="graphExcelDownloadBtn"
                />
              </span>
            </h2>
            <ul className="descriptionUl">
              <li>{this.state.assetDetails.propertytype}</li>
              <li>{this.state.assetDetails.micromarket}</li>
              <li>{this.state.assetDetails.grade}</li>
            </ul>
            <div className="row rowAsset">
              <div className="col-lg-4">
                <ul className="detailsUl">
                  <li>
                    <span>Year constructed</span>
                    <span>{this.state.assetDetails.year_constructed}</span>
                  </li>
                  <li className="liBlueBg">
                    {" "}
                    <span>Developer</span>
                    <span>{this.state.assetDetails.developer}</span>
                  </li>
                  <li>
                    {" "}
                    <span>Status</span>
                    <span>{this.state.assetDetails.status}</span>
                  </li>
                  <li>
                    <span>Total Leasable Area</span>
                    <span>
                      {this.state.assetDetails.total_leasable_area} {"msf"}
                    </span>
                  </li>
                  {/* <li>
                    {" "}
                    <span>Ownership Type</span>
                    <span>{this.state.assetDetails.year_constructed}</span>
                  </li>
                  <li className="liBlueBg">
                    {" "}
                    <span>Owner(s)</span>
                    <span>{this.state.assetDetails.year_constructed}</span>
                  </li> */}
                </ul>
              </div>
              <div className="col-lg-4">
                <ul className="detailsUl">
                  <li className="liBlueBg">
                    {" "}
                    <span>Area Vacant</span>
                    <span>
                      {this.state.assetDetails.area_vacant} {"msf"}
                    </span>
                  </li>
                  <li>
                    {" "}
                    <span>Asset Efficiency</span>
                    <span>
                      {this.state.assetDetails.asset_efficiency} {"%"}
                    </span>
                  </li>
                  <li className="liBlueBg">
                    {" "}
                    <span>WALE</span>
                    <span>
                      {this.state.assetDetails.wale} {"months"}
                    </span>
                  </li>
                  <li>
                    {" "}
                    <span># of Active Tenants</span>
                    <span>{this.state.assetDetails.no_of_active_tenants}</span>
                  </li>
                </ul>
              </div>
              <div className="col-lg-4">
                <ul className="detailsUl">
                  <li>
                    <span>Upcoming Area</span>
                    <span>
                      {this.state.assetDetails.upcoming_area} {"msf"}
                    </span>
                  </li>
                  <li className="liBlueBg">
                    {" "}
                    <span>Market Rent</span>
                    <span>
                      {this.state.assetDetails.market_rent} {"₹/sqft/month"}
                    </span>
                  </li>
                  <li>
                    {" "}
                    <span>5-Yr CAGR Rent</span>
                    <span>{this.state.assetDetails.five_year_cagr_rent}</span>
                  </li>
                  {/* <li className="liBlueBg">
                    {" "}
                    <span>Valuation*</span>
                    <span>{this.state.assetDetails.year_constructed}</span>
                  </li>
                  <li>
                    {" "}
                    <span>Mortgage Attached</span>
                    <span>{this.state.assetDetails.year_constructed}</span>
                  </li> */}
                </ul>
              </div>
            </div>
          </div>
          <div className="col-lg-2 contentBlue">
            <div
              className="customWidget customWidget1st"
              style={{ paddingTop: "10px" }}
            >
              <div className="row">
                <div className="infoCircle text-end">
                  <FontAwesomeIcon
                    icon={faInfoCircle}
                    style={{ color: "#cccccc" }}
                  />
                  <div className="vacancyInfo1" style={{ display: "none" }}>
                    <p className="text-center">
                      Vacancy is based on registered leases only
                    </p>
                  </div>
                </div>
                <div className="col-lg-4 flexCenter">
                  <h3>
                    <FontAwesomeIcon icon={faSearch} className="colorWhite" />
                  </h3>
                </div>
                <div className="col-lg-8">
                  {/* <h2 className="colorWhite">
                    {this.state.assetDetails.current_vacancy}%
                  </h2> */}
                  <h2 className="colorWhite">
                    {this.state.assetDetails.current_vacancy}
                    <span style={{ fontSize: "12px", padding: "5px" }}>%</span>
                  </h2>
                  <p className="colorWhite">Current Vacancy(%)</p>
                </div>
              </div>
            </div>
            <div
              className="customWidget customWidget2nd"
              style={{ borderBottom: "0" }}
            >
              <div className="row">
                <div className="col-lg-4 flexCenter">
                  <h3>
                    <img
                      src="/edge/images/current_passing_rent_white.png"
                      width={"45px"}
                    />
                  </h3>
                </div>
                <div className="col-lg-8">
                  <h2 className="colorWhite">
                    {this.state.assetDetails.current_in_place_rentals}
                  </h2>
                  <p className="colorWhite">Sqft/Month</p>
                  <p className="colorWhite" style={{ fontSize: "10px" }}>
                    Current in Place Rentals
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default connect(mapStateToProps)(AssetDetails);
